import { commonShortNouns } from "./common-short-fields";

export const examAdminCustomFieldDefinitions = {
  pageTitle: "カスタム項目",
  pageSubtitle: "受験者・試験・イメージのカスタム項目定義と業務属性を管理します。",
  archiveAction: "アーカイブ",
  createSuccess: "項目を作成しました",
  updateSuccess: "項目を更新しました",
  archiveSuccess: "項目をアーカイブしました",
  confirmArchiveTitle: "この項目をアーカイブしますか？",
  targets: {
    candidate: "受験者",
    exam: "試験",
    docker_image: "イメージ",
  },
  objects: {
    field: "項目",
  },
  table: {
    target: "対象",
    fieldKey: "キー",
    fieldLabel: "名称",
    dataType: "型",
    visibility: "表示",
    editability: "編集可否",
    requiredOnLogin: "ログイン時必須",
    status: commonShortNouns.status,
    actions: "操作",
  },
  form: {
    target: "対象",
    fieldKey: "項目キー",
    fieldLabel: "項目名",
    dataType: "項目タイプ",
    requiredOnLogin: "ログイン時必須（受験者のみ）",
    visibility: "表示",
    editability: "編集可否",
    optionsText: "選択肢（1 行 1 件、select/multi_select 用）",
    placeholder: "プレースホルダー",
    helpText: "ヘルプテキスト",
    sortOrder: "並び順",
    status: commonShortNouns.status,
    placeholders: {
      fieldKey: "例：employee_no / emergency_contact",
      fieldLabel: "例：社員番号 / 緊急連絡先",
      optionsText: "例：\n初級\n中級\n上級",
      placeholder: "例：社員番号を入力してください",
      helpText: "例：ログイン後のプロフィール補完に使用",
      sortOrder: "例：10（数値が小さいほど前に表示）",
    },
  },
  labels: {
    active: "有効",
    archived: "アーカイブ済み",
    visible: "表示",
    hidden: "非表示",
    editable: "編集可能",
    readonly: "読み取り専用",
  },
};
